import { render, staticRenderFns } from "./UndefinedIcon.vue?vue&type=template&id=71d8050a&functional=true"
import script from "./UndefinedIcon.vue?vue&type=script&lang=js"
export * from "./UndefinedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports